import { useEffect } from "react";

const SEO_TITLE = "WorkScope | Client Approval Links for Estimates, Change Orders & Extra Work";
const SEO_DESCRIPTION =
  "Send secure approval links for Estimates, Change Orders & Extra Work. Clients approve/reject/clarify instantly. Automatic reminders, PDFs, attachments, and audit trail.";
const SEO_URL = "https://workscope.app/";
const SEO_IMAGE = "https://workscope.app/og.png";

const JSON_LD = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: "WorkScope",
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  url: SEO_URL,
  description: SEO_DESCRIPTION,
  offers: [
    {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
      category: "Free",
    },
    {
      "@type": "Offer",
      price: "49-64",
      priceCurrency: "USD",
      category: "Pro/Team",
    },
  ],
  brand: {
    "@type": "Brand",
    name: "WorkScope",
  },
};

function ensureMeta(selector: string, attributes: Record<string, string>) {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([key, value]) => element!.setAttribute(key, value));
}

export default function MarketingSeo() {
  useEffect(() => {
    document.title = SEO_TITLE;

    ensureMeta('meta[name="description"]', { name: "description", content: SEO_DESCRIPTION });
    ensureMeta('meta[property="og:title"]', { property: "og:title", content: SEO_TITLE });
    ensureMeta('meta[property="og:description"]', { property: "og:description", content: SEO_DESCRIPTION });
    ensureMeta('meta[property="og:url"]', { property: "og:url", content: SEO_URL });
    ensureMeta('meta[property="og:type"]', { property: "og:type", content: "website" });
    ensureMeta('meta[property="og:image"]', { property: "og:image", content: SEO_IMAGE });
    ensureMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    ensureMeta('meta[name="twitter:title"]', { name: "twitter:title", content: SEO_TITLE });
    ensureMeta('meta[name="twitter:description"]', { name: "twitter:description", content: SEO_DESCRIPTION });
    ensureMeta('meta[name="twitter:image"]', { name: "twitter:image", content: SEO_IMAGE });
    let script = document.head.querySelector<HTMLScriptElement>('script[data-workscope-seo="softwareapplication"]');
    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.workscopeSeo = "softwareapplication";
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(JSON_LD);
  }, []);

  return null;
}
